import BrandNew from './BrandNew';

export default BrandNew;
